import { Pipe, PipeTransform } from "@angular/core";
import { IOComponent, ObsComponent } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "getComponent" })
export class GetComponentPipe implements PipeTransform {
  transform(headerCompo: IOComponent, component: IOComponent[]): ObsComponent {
    let comp: IOComponent;
    for (const compo of component) {
      if (
        compo.parentObservation?.code?.coding[0].code === headerCompo.parentObservation.code.coding[0].code &&
        compo.code.coding[0].code === headerCompo.code.coding[0].code
      ) {
        comp = compo;
      }
    }
    return new ObsComponent(comp);
  }
}
